import axios from "axios";

const API = axios.create({
  baseURL: "https://courierbackend-production-8dd7.up.railway.app",
});

export default API;